import React from "react"
import Drawer from "@material-ui/core/Drawer"
import ChevronRightIcon from "@material-ui/icons/ChevronRight"
import IconButton from "@material-ui/core/IconButton"
import { Link} from "gatsby";

const DrawerComponent = props => {
    
  return (
    <Drawer variant="persistent" anchor="right" open={props.open}>
      <div className="Drawer">
      <IconButton onClick={props.handleCloseDrawer}>
        <ChevronRightIcon className="Drawer-iconWrapper" />
      </IconButton>
      <ul className="Drawer-list">
            <Link to='/about' onClick={props.handleCloseDrawer} className="Drawer-listItem" activeClassName="Drawer--active">About</Link>
            <Link to='/gallery' onClick={props.handleCloseDrawer} className="Drawer-listItem" activeClassName="Drawer--active">Gallery</Link>
            <Link to='/resume' onClick={props.handleCloseDrawer} className="Drawer-listItem" activeClassName="Drawer--active">Resume</Link>
            <Link to='/coaching' onClick={props.handleCloseDrawer} className="Drawer-listItem" activeClassName="Drawer--active">Coaching</Link>
            <Link to='/kudos' onClick={props.handleCloseDrawer} className="Drawer-listItem" activeClassName="Drawer--active">Kudos</Link>
            <Link to='/contact' onClick={props.handleCloseDrawer} className="Drawer-listItem" activeClassName="Drawer--active">Contact</Link>
        </ul>
        </div>
    </Drawer>
  )
}

export default DrawerComponent
